import { put, call, takeLatest } from "redux-saga/effects";
import { showErrorToast } from "util/toastUtils";
import {
    todaysReservationOverviewSuccess, todaysReservationOverviewFailure, todaysReservationVolumeBySessionSuccess, todaysReservationVolumeBySessionFailure, todaysAssignedReservationSuccess, todaysAssignedReservationFailure, todaysUpcomingReservationSuccess, todaysUpcomingReservationFailure, upcomingReservationOverviewSuccess, upcomingReservationOverviewFailure, upcomingReservationVolumeBySessionSuccess, upcomingReservationVolumeBySessionFailure, upcomingReservationVolumeSuccess, upcomingReservationVolumeFailure, upcomingReservationBySessionSuccess, upcomingReservationBySessionFailure, upcomingReservationStatusByDateSuccess, upcomingReservationStatusByDateFailure, upcomingReservationCancellationByReasonsSuccess, upcomingReservationCancellationByReasonsFailure, upcomingReservationDetailsSuccess, upcomingReservationDetailsFailure, reservationOverviewSuccess, reservationOverviewFailure, reservationOverviewSlotWiseReservationSuccess, reservationOverviewSlotWiseReservationFailure, reservationOverviewDailyReservationsGuestsSuccess, reservationOverviewDailyReservationsGuestsFailure, reservationOverviewDineInDurationByGroupsSuccess, reservationOverviewDineInDurationByGroupsFailure, reservationOverviewGuestSizeDistributionSuccess, reservationOverviewGuestSizeDistributionFailure, reservationOverviewDetailsSuccess, reservationOverviewDetailsFailure, reservationTrendOverviewSuccess, reservationTrendOverviewFailure, reservationTrendSuccess, reservationTrendFailure, reservationTrendByGroupsSuccess, reservationTrendByGroupsFailure, reservationTrendByAvgWaitTimeSuccess, reservationTrendByAvgWaitTimeFailure, reservationTrendCustomerTrendSuccess, reservationTrendCustomerTrendFailure, reservationTrendCustomerVisitsSuccess, reservationTrendCustomerVisitsFailure
} from "./reservationReportsActions";
import {
    TODAYS_RESERVATION_OVERVIEW_REQUEST,
    TODAYS_RESERVATION_VOLUME_BY_SESSION_REQUEST,
    TODAYS_ASSIGNED_RESERVATION_REQUEST,
    TODAYS_UPCOMING_RESERVATION_REQUEST,
    UPCOMING_RESERVATION_OVERVIEW_REQUEST,
    UPCOMING_RESERVATION_VOLUME_BY_SESSION_REQUEST,
    UPCOMING_RESERVATION_VOLUME_REQUEST,
    UPCOMING_RESERVATION_BY_SESSION_REQUEST,
    UPCOMING_RESERVATION_STATUS_BY_DATE_REQUEST,
    UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_REQUEST,
    UPCOMING_RESERVATION_DETAILS_REQUEST,
    RESERVATION_OVERVIEW_REQUEST,
    RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_REQUEST,
    RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_REQUEST,
    RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_REQUEST,
    RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_REQUEST,
    RESERVATION_OVERVIEW_DETAILS_REQUEST,
    RESERVATION_TREND_OVERVIEW_REQUEST,
    RESERVATION_TREND_REQUEST,
    RESERVATION_TREND_BY_GROUPS_REQUEST,
    RESERVATION_TREND_BY_AVG_WAIT_TIME_REQUEST,
    RESERVATION_TREND_CUSTOMER_TREND_REQUEST,
    RESERVATION_TREND_CUSTOMER_VISITS_REQUEST

} from "./reservationReportsConstants";
import {
    getTodaysReservationOverview, getTodaysReservationVolumeBySession, getTodaysAssignedReservation, getTodaysUpcomingReservation, getUpcomingReservationOverview, getUpcomingReservationVolumeBySession, getUpcomingReservationVolume, getUpcomingReservationBySession, getUpcomingReservationStatusByDate, getUpcomingReservationCancellationByReasons, getUpcomingReservationDetails, getReservationOverview, getReservationOverviewSlotWiseReservation, getReservationOverviewDailyReservationsGuests, getReservationOverviewDineInDurationByGroups, getReservationOverviewGuestSizeDistribution, getReservationOverviewDetails, getReservationTrendOverview, getReservationTrend, getReservationTrendByGroups, getReservationTrendByAvgWaitTime, getReservationTrendCustomerTrend, getReservationTrendCustomerVisits
} from "./reservationReportsApi";
import { decryptJson } from "util/react-ec-utils";

export function* todaysReservationOverviewSaga(action) {
    try {
        const response = yield call(getTodaysReservationOverview, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(todaysReservationOverviewSuccess(decryptedData));
        } else {
            yield put(todaysReservationOverviewFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(todaysReservationOverviewFailure(error));
    }
}

// Today's Reservation Volume by Session Saga
export function* todaysReservationVolumeBySessionSaga(action) {
    try {
        const response = yield call(getTodaysReservationVolumeBySession, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(todaysReservationVolumeBySessionSuccess(decryptedData));
        } else {
            yield put(todaysReservationVolumeBySessionFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(todaysReservationVolumeBySessionFailure(error));
    }
}

// Today's Assigned Reservation Saga
export function* todaysAssignedReservationSaga(action) {
    try {
        const response = yield call(getTodaysAssignedReservation, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(todaysAssignedReservationSuccess(decryptedData));
        } else {
            yield put(todaysAssignedReservationFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(todaysAssignedReservationFailure(error));
    }
}

// Today's Upcoming Reservation Saga
export function* todaysUpcomingReservationSaga(action) {
    try {
        const response = yield call(getTodaysUpcomingReservation, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(todaysUpcomingReservationSuccess(decryptedData));
        } else {
            yield put(todaysUpcomingReservationFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(todaysUpcomingReservationFailure(error));
    }
}

// Upcoming Reservation Overview Saga
export function* upcomingReservationOverviewSaga(action) {
    try {
        const response = yield call(getUpcomingReservationOverview, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(upcomingReservationOverviewSuccess(decryptedData));
        } else {
            yield put(upcomingReservationOverviewFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(upcomingReservationOverviewFailure(error));
    }
}

// Upcoming Reservation Volume by Session Saga
export function* upcomingReservationVolumeBySessionSaga(action) {
    try {
        const response = yield call(getUpcomingReservationVolumeBySession, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(upcomingReservationVolumeBySessionSuccess(decryptedData));
        } else {
            yield put(upcomingReservationVolumeBySessionFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(upcomingReservationVolumeBySessionFailure(error));
    }
}

// Upcoming Reservation Volume Saga
export function* upcomingReservationVolumeSaga(action) {
    try {
        const response = yield call(getUpcomingReservationVolume, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(upcomingReservationVolumeSuccess(decryptedData));
        } else {
            yield put(upcomingReservationVolumeFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(upcomingReservationVolumeFailure(error));
    }
}

// Upcoming Reservation by Session Saga
export function* upcomingReservationBySessionSaga(action) {
    try {
        const response = yield call(getUpcomingReservationBySession, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(upcomingReservationBySessionSuccess(decryptedData));
        } else {
            yield put(upcomingReservationBySessionFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(upcomingReservationBySessionFailure(error));
    }
}

// Upcoming Reservation Status by Date Saga
export function* upcomingReservationStatusByDateSaga(action) {
    try {
        const response = yield call(getUpcomingReservationStatusByDate, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(upcomingReservationStatusByDateSuccess(decryptedData));
        } else {
            yield put(upcomingReservationStatusByDateFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(upcomingReservationStatusByDateFailure(error));
    }
}

// Upcoming Reservation Cancellation by Reasons Saga
export function* upcomingReservationCancellationByReasonsSaga(action) {
    try {
        const response = yield call(getUpcomingReservationCancellationByReasons, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(upcomingReservationCancellationByReasonsSuccess(decryptedData));
        } else {
            yield put(upcomingReservationCancellationByReasonsFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(upcomingReservationCancellationByReasonsFailure(error));
    }
}

// Upcoming Reservation Details Saga
export function* upcomingReservationDetailsSaga(action) {
    try {
        const response = yield call(getUpcomingReservationDetails, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(upcomingReservationDetailsSuccess(decryptedData));
        } else {
            yield put(upcomingReservationDetailsFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(upcomingReservationDetailsFailure(error));
    }
}
// Reservation Overview Saga
export function* reservationOverviewSaga(action) {
    try {
        const response = yield call(getReservationOverview, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(reservationOverviewSuccess(decryptedData));
        } else {
            yield put(reservationOverviewFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(reservationOverviewFailure(error));
    }
}

// Reservation Overview Slot Wise Reservation Saga
export function* reservationOverviewSlotWiseReservationSaga(action) {
    try {
        const response = yield call(getReservationOverviewSlotWiseReservation, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(reservationOverviewSlotWiseReservationSuccess(decryptedData));
        } else {
            yield put(reservationOverviewSlotWiseReservationFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(reservationOverviewSlotWiseReservationFailure(error));
    }
}

// Reservation Overview Daily Reservations Guests Saga
export function* reservationOverviewDailyReservationsGuestsSaga(action) {
    try {
        const response = yield call(getReservationOverviewDailyReservationsGuests, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(reservationOverviewDailyReservationsGuestsSuccess(decryptedData));
        } else {
            yield put(reservationOverviewDailyReservationsGuestsFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(reservationOverviewDailyReservationsGuestsFailure(error));
    }
}

// Reservation Overview Dine-In Duration by Groups Saga
export function* reservationOverviewDineInDurationByGroupsSaga(action) {
    try {
        const response = yield call(getReservationOverviewDineInDurationByGroups, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(reservationOverviewDineInDurationByGroupsSuccess(decryptedData));
        } else {
            yield put(reservationOverviewDineInDurationByGroupsFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(reservationOverviewDineInDurationByGroupsFailure(error));
    }
}

// Reservation Overview Guest Size Distribution Saga
export function* reservationOverviewGuestSizeDistributionSaga(action) {
    try {
        const response = yield call(getReservationOverviewGuestSizeDistribution, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(reservationOverviewGuestSizeDistributionSuccess(decryptedData));
        } else {
            yield put(reservationOverviewGuestSizeDistributionFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(reservationOverviewGuestSizeDistributionFailure(error));
    }
}

// Reservation Overview Details Saga
export function* reservationOverviewDetailsSaga(action) {
    try {
        const response = yield call(getReservationOverviewDetails, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(reservationOverviewDetailsSuccess(decryptedData));
        } else {
            yield put(reservationOverviewDetailsFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(reservationOverviewDetailsFailure(error));
    }
}

// Reservation Trend Overview Saga
export function* reservationTrendOverviewSaga(action) {
    try {
        const response = yield call(getReservationTrendOverview, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(reservationTrendOverviewSuccess(decryptedData));
        } else {
            yield put(reservationTrendOverviewFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(reservationTrendOverviewFailure(error));
    }
}

// Reservation Trend Saga
export function* reservationTrendSaga(action) {
    try {
        const response = yield call(getReservationTrend, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(reservationTrendSuccess(decryptedData));
        } else {
            yield put(reservationTrendFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(reservationTrendFailure(error));
    }
}

// Reservation Trend by Groups Saga
export function* reservationTrendByGroupsSaga(action) {
    try {
        const response = yield call(getReservationTrendByGroups, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(reservationTrendByGroupsSuccess(decryptedData));
        } else {
            yield put(reservationTrendByGroupsFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(reservationTrendByGroupsFailure(error));
    }
}

// Reservation Trend by Average Wait Time Saga
export function* reservationTrendByAvgWaitTimeSaga(action) {
    try {
        const response = yield call(getReservationTrendByAvgWaitTime, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(reservationTrendByAvgWaitTimeSuccess(decryptedData));
        } else {
            yield put(reservationTrendByAvgWaitTimeFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(reservationTrendByAvgWaitTimeFailure(error));
    }
}

// Reservation Trend Customer Trend Saga
export function* reservationTrendCustomerTrendSaga(action) {
    try {
        const response = yield call(getReservationTrendCustomerTrend, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(reservationTrendCustomerTrendSuccess(decryptedData));
        } else {
            yield put(reservationTrendCustomerTrendFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(reservationTrendCustomerTrendFailure(error));
    }
}

// Reservation Trend Customer Visits Saga
export function* reservationTrendCustomerVisitsSaga(action) {
    try {
        const response = yield call(getReservationTrendCustomerVisits, action.payload);
        const decryptedData = decryptJson(response?.data?.encryptedText);
        if (response.status === 200) {
            yield put(reservationTrendCustomerVisitsSuccess(decryptedData));
        } else {
            yield put(reservationTrendCustomerVisitsFailure(decryptedData?.message));
            showErrorToast(decryptedData?.message);
        }
    } catch (error) {
        yield put(reservationTrendCustomerVisitsFailure(error));
    }
}


export default function* watchNewReportRequest() {
    yield takeLatest(TODAYS_RESERVATION_OVERVIEW_REQUEST, todaysReservationOverviewSaga);
    yield takeLatest(TODAYS_RESERVATION_VOLUME_BY_SESSION_REQUEST, todaysReservationVolumeBySessionSaga);
    yield takeLatest(TODAYS_ASSIGNED_RESERVATION_REQUEST, todaysAssignedReservationSaga);
    yield takeLatest(TODAYS_UPCOMING_RESERVATION_REQUEST, todaysUpcomingReservationSaga);
    yield takeLatest(UPCOMING_RESERVATION_OVERVIEW_REQUEST, upcomingReservationOverviewSaga);
    yield takeLatest(UPCOMING_RESERVATION_VOLUME_BY_SESSION_REQUEST, upcomingReservationVolumeBySessionSaga);
    yield takeLatest(UPCOMING_RESERVATION_VOLUME_REQUEST, upcomingReservationVolumeSaga);
    yield takeLatest(UPCOMING_RESERVATION_BY_SESSION_REQUEST, upcomingReservationBySessionSaga);
    yield takeLatest(UPCOMING_RESERVATION_STATUS_BY_DATE_REQUEST, upcomingReservationStatusByDateSaga);
    yield takeLatest(UPCOMING_RESERVATION_CANCELLATION_BY_REASONS_REQUEST, upcomingReservationCancellationByReasonsSaga);
    yield takeLatest(UPCOMING_RESERVATION_DETAILS_REQUEST, upcomingReservationDetailsSaga);
    yield takeLatest(RESERVATION_OVERVIEW_REQUEST, reservationOverviewSaga);
    yield takeLatest(RESERVATION_OVERVIEW_SLOT_WISE_RESERVATION_REQUEST, reservationOverviewSlotWiseReservationSaga);
    yield takeLatest(RESERVATION_OVERVIEW_DAILY_RESERVATIONS_GUESTS_REQUEST, reservationOverviewDailyReservationsGuestsSaga);
    yield takeLatest(RESERVATION_OVERVIEW_DINE_IN_DURATION_BY_GROUPS_REQUEST, reservationOverviewDineInDurationByGroupsSaga);
    yield takeLatest(RESERVATION_OVERVIEW_GUEST_SIZE_DISTRIBUTION_REQUEST, reservationOverviewGuestSizeDistributionSaga);
    yield takeLatest(RESERVATION_OVERVIEW_DETAILS_REQUEST, reservationOverviewDetailsSaga);
    yield takeLatest(RESERVATION_TREND_OVERVIEW_REQUEST, reservationTrendOverviewSaga);
    yield takeLatest(RESERVATION_TREND_REQUEST, reservationTrendSaga);
    yield takeLatest(RESERVATION_TREND_BY_GROUPS_REQUEST, reservationTrendByGroupsSaga);
    yield takeLatest(RESERVATION_TREND_BY_AVG_WAIT_TIME_REQUEST, reservationTrendByAvgWaitTimeSaga);
    yield takeLatest(RESERVATION_TREND_CUSTOMER_TREND_REQUEST, reservationTrendCustomerTrendSaga);
    yield takeLatest(RESERVATION_TREND_CUSTOMER_VISITS_REQUEST, reservationTrendCustomerVisitsSaga);

}